import { bulmaInit, datadogInit } from '../../common';
import './login.scss';

datadogInit();
bulmaInit();
